/**
 * @constant AvailableFlags
 * Array of flags keys
 */
const AvailableFlags = ['debug', 'debugPrebid', 'disableRefresh', 'pid', 'selector', 'bidder', 'mediaType', 'tester', 'adslot'];
/**
 * @constant _Flags (private)
 * Get all flags from URL & session storage
 */
const _Flags = {
    // Flags from URL hash
    ...window.location.hash.replace('#', '').split('&')
        .reduce((obj, hash) => {
        const [key, value] = hash.split('=');
        obj[key] = value || true;
        return obj;
    }, {}),
    // Flags from sessionStorage
    ...JSON.parse(sessionStorage.getItem(__APP_NAME__) || "{}")
};
/**
 * @constant Flags (public)
 * Filter flags belonging to AvailableFlags only
 */
const Flags = Object.fromEntries(Object.entries(_Flags).filter(([hash, _value]) => AvailableFlags.includes(hash)));
export default Flags;
